import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllDiscountUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllDiscount/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllDiscountUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllDiscountUser;
};


const setActiveDiscount = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setDiscountActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllDiscountUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Discount  - ',response);


    return AllDiscountUser;
};



const setDeletedDiscount = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setDiscountDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllDiscountUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Discount  - ',response);


    return AllDiscountUser;
};




const setUpdateDiscount = async (dataDiscountUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setDiscountUpdate/'),{
        dataDiscountUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllDiscountUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Discount  - ',dataDiscountUpdate,response);


    return AllDiscountUser;
};


const setSaveNewDiscount = async (dataDiscountUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewDiscount/'),{
        dataDiscountUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllDiscountUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Discount  - ',response);


    return AllDiscountUser;
};

Mock.onGet('/api/reference/getAllDiscount').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllDiscountUser = await getAllDiscountUser();
    // console.log('С сервера пришло - ', AllDiscountUser);

    // if (!AllDiscountUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllDiscountUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllDiscountUser,
    ]


})


Mock.onPost('/api/reference/setActiveDiscount').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllDiscountUser = await setActiveDiscount(id,val);

    // if (!AllDiscountUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllDiscountUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllDiscountUser,
    ]


})

Mock.onPost('/api/reference/setDeletedDiscount').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllDiscountUser = await setDeletedDiscount(id,val);

    // if (!AllDiscountUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllDiscountUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllDiscountUser,
    ]


})


Mock.onPost('/api/reference/setUpdateDiscount').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataDiscountUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Discount = await setUpdateDiscount(dataDiscountUpdate);

    // console.log('Серовер вернул данные ',AllDiscountUser);

    // if (!Discount) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Discount) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Discount,
    ]


})


Mock.onPost('/api/reference/setSaveNewDiscount').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataDiscountUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Discount = await setSaveNewDiscount(dataDiscountUpdate);

    // console.log('Серовер вернул данные ',AllDiscountUser);

    // if (!Discount) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Discount) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Discount,
    ]
})